import api from './api';

export interface SetupIntentResponse {
  setupIntentId: string;
  clientSecret: string;
}

export interface SetDefaultPaymentMethodRequest {
  agencyId: string;
  setupIntentId: string;
}

export interface Card {
  id: string;
  brand: string;
  lastFourDigits: string;
  expirationMonth: number;
  expirationYear: number;
}

export const createSetupIntent = async ({
  agencyId,
}: {
  agencyId: string;
}): Promise<SetupIntentResponse> => {
  const response = await api.post(
    '/api/v1/billing/setup-intent',
    {},
    { headers: { 'x-agency-id': agencyId } },
  );
  return response.data;
};

export const setDefaultPaymentMethod = async ({
  agencyId,
  setupIntentId,
}: SetDefaultPaymentMethodRequest): Promise<Card> => {
  const response = await api.post(
    '/api/v1/billing/payment-method/default',
    { setupIntentId },
    { headers: { 'x-agency-id': agencyId } },
  );
  return response.data;
};

export interface CloudStudioSubscriptionItem {
  priceId: string;
  shortLabel: string;
  workspaceCount: number;
}

export interface CloudStudioProductBreakdown {
  productId: string;
  productName: string;
  items: CloudStudioSubscriptionItem[];
}

export const getCloudStudioBreakdown = async ({
  agencyId,
}: {
  agencyId: string;
}): Promise<CloudStudioProductBreakdown[]> => {
  const response = await api.get(
    '/api/v1/billing/cloudstudio-breakdown',
    { headers: { 'x-agency-id': agencyId } },
  );
  return response.data;
};
